import React from 'react';
import { PublicPage, PublicCard } from '../PublicPage';

/**
 * Our Expertise, mirroring facilonservices.co.in/our-expertise.
 *
 * The published page carries its meaning in six illustrated cards; those graphics are
 * reused here as-is (user decision 2026-09-12) rather than redrawn, so the capability
 * set an investor sees matches the marketing site exactly.
 */

const INTRO =
  'FACILON provides a comprehensive suite of solutions to facilitate the onboarding and ongoing support of investors, through a network of custodians, banks, brokers and other intermediaries and agents as needed.';

const NETWORK_POINTS = [
  'Access and evaluate list of FACILON registered service providers & their product offerings.',
  'Expedite the service provider appointment process',
  'Navigate complexities of the securities market with confidence',
];

const ONBOARDING_CAPABILITIES = [
  { title: 'Streamlined Onboarding Process', image: '/assets/images/site/our-expertise-1.png' },
  { title: 'Enhanced Efficiency', image: '/assets/images/site/our-expertise-3.png' },
  { title: 'Reduced Timelines', image: '/assets/images/site/our-expertise-4.png' },
];

const EXPERIENCE_CAPABILITIES = [
  { title: 'A Unique Single Window Facility', image: '/assets/images/site/our-expertise-5.png' },
  { title: 'Inspiring Intermediaries to Expand Horizons', image: '/assets/images/site/our-expertise-3.png' },
  { title: 'A Pioneer in Comprehensive Solutions', image: '/assets/images/site/our-expertise-3.png' },
];

const CapabilityGrid: React.FC<{ items: { title: string; image: string }[] }> = ({ items }) => (
  <div className="capability-grid">
    {items.map((item) => (
      <div className="capability-card" key={item.title}>
        <img src={item.image} alt="" loading="lazy" />
        <p className="capability-title">{item.title}</p>
      </div>
    ))}
  </div>
);

export const OurExpertise: React.FC = () => (
  <PublicPage
    title="Our Expertise"
    subtitle="How Facilon connects investors with a network of service providers."
    icon="bi-stars"
  >
    <PublicCard>
      <div className="page-prose">
        <p>{INTRO}</p>
      </div>
    </PublicCard>

    <PublicCard title="Connecting investors with a network of service providers" icon="bi-diagram-3-fill">
      <div className="page-prose mb-4">
        <ul>
          {NETWORK_POINTS.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      </div>
      <CapabilityGrid items={ONBOARDING_CAPABILITIES} />
    </PublicCard>

    <PublicCard title="Revolutionizing the Investors' Experience" icon="bi-lightbulb-fill">
      <CapabilityGrid items={EXPERIENCE_CAPABILITIES} />
    </PublicCard>
  </PublicPage>
);

export default OurExpertise;
